import { formatEur } from '@wf/shared'
import { InfoTip } from '../ui/InfoTip'
import { useAdminStats } from './useAdmin'

// SaaS-KPI-Widget des Betreiber-Dashboards. Gerechnet wird im Backend über @wf/shared/operator.ts
// (eine Wahrheit) — hier nur Anzeige. Bewusst OHNE Churn-Rate: dafür fehlt eine Abrechnungs-Historie;
// ein ehrliches „—" wäre Rauschen. Wachstums-Proxy = neue Werkstätten (30/90 T) + Aktivität (DAU/WAU).

export function AdminStatsPanel() {
  const { data, isLoading, isError } = useAdminStats()

  if (isLoading) return <div className="muted">Kennzahlen werden geladen…</div>
  if (isError || !data) return <div className="error" role="alert">Kennzahlen konnten nicht geladen werden.</div>

  const planBreakdown = data.byPlan
    .filter((p) => p.count > 0)
    .map((p) => `${p.count}× ${p.plan}${p.mrrCents > 0 ? ` (${formatEur(p.mrrCents)})` : ''}`)
    .join(' · ')

  return (
    <section className="wf-saaskpis" aria-label="SaaS-Kennzahlen">
      <div className="wf-statrow wf-saaskpis__grid">
        <div className="wf-stat">
          <div className="wf-stat__label">
            MRR
            <InfoTip
              title="MRR — Monatlich wiederkehrender Umsatz"
              purpose="Summe der Tarifpreise aller AKTIVEN Werkstätten. Gesperrte/gekündigte zählen nicht; test/probe/owner kosten 0 €."
            />
          </div>
          <div className="wf-stat__value">{formatEur(data.mrrCents)}</div>
          <div className="wf-stat__sub">≈ {formatEur(data.mrrCents * 12)} pro Jahr</div>
        </div>
        <div className="wf-stat">
          <div className="wf-stat__label">
            Zahlende Lizenzen
            <InfoTip
              title="Zahlende Lizenzen"
              purpose="Aktive Werkstätten mit Tarifpreis über 0 € — Test-, Probe- und Owner-Instanzen zählen nicht als Kunden."
            />
          </div>
          <div className="wf-stat__value">{data.payingCount}</div>
          <div className="wf-stat__sub">Ø {formatEur(data.arpaCents)} je Account (ARPA)</div>
        </div>
        <div className="wf-stat">
          <div className="wf-stat__label">
            Werkstätten
            <InfoTip
              title="Werkstätten nach Status"
              purpose="Alle Mandanten der Plattform, aufgeteilt nach Lizenz-Status."
              lines={[
                { label: 'Aktiv', text: `${data.byStatus.active}` },
                { label: 'Gesperrt', text: `${data.byStatus.suspended}`, warn: data.byStatus.suspended > 0 },
                { label: 'Gekündigt', text: `${data.byStatus.canceled}`, warn: data.byStatus.canceled > 0 },
              ]}
            />
          </div>
          <div className="wf-stat__value">{data.workshopsTotal}</div>
          <div className="wf-stat__sub">
            {data.byStatus.active} aktiv
            {data.byStatus.suspended > 0 ? ` · ${data.byStatus.suspended} gesperrt` : ''}
            {data.byStatus.canceled > 0 ? ` · ${data.byStatus.canceled} gekündigt` : ''}
          </div>
        </div>
        <div className="wf-stat">
          <div className="wf-stat__label">
            Wachstum
            <InfoTip
              title="Wachstum"
              purpose="Neu angelegte Werkstätten. Solange es keine Abrechnungs-Historie gibt, ist das der ehrliche Wachstums-Indikator (statt einer geratenen Churn-Rate)."
            />
          </div>
          <div className="wf-stat__value">+{data.newWorkshops30d}</div>
          <div className="wf-stat__sub">letzte 30 T · +{data.newWorkshops90d} in 90 T</div>
        </div>
        <div className="wf-stat">
          <div className="wf-stat__label">
            Aktive Nutzer
            <InfoTip
              title="Aktive Nutzer"
              purpose="Nutzer (ohne Betreiber) mit Session-Aktivität — Tages- und Wochen-Aktivität als Nutzungs-Indikator."
            />
          </div>
          <div className="wf-stat__value">{data.activeUsersToday}</div>
          <div className="wf-stat__sub">heute · {data.activeUsers7d} in 7 Tagen</div>
        </div>
      </div>
      {planBreakdown && <div className="wf-saaskpis__plans muted">Tarife: {planBreakdown}</div>}
    </section>
  )
}
